module.exports = __webpack_public_path__ + "img/flot3.920f95ee.svg";